import { TableData, TableRow } from "MVVM/Views/MatchHistory/styledComponents";
import { LoadingSkeleton } from "MVVM/Components/Skeloton";
import { Flex } from "rebass/styled-components";
const MatchesLoading = ({
  colSpan,
  rows,
}: {
  colSpan?: number;
  rows?: number;
}) => {
  return (
    <>
      {Array(rows || 3)
        .fill("")
        .map((_, index) => (
          <TableRow key={index}>
            <TableData colSpan={colSpan || 6}>
              <LoadingSkeleton height={100} />
            </TableData>
          </TableRow>
        ))}
    </>
  );
};

export const MomentsLoading = () => {
  return (
    <Flex
      style={{
        width: "100%",
        gap: 20,
        flexDirection: "column",
        minHeight: 335,
      }}
    ></Flex>
  );
};

export { MatchesLoading };
